<template>
  <router-view />
</template>

<script>
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth.store'

export default {
  name: 'App',

  setup() {
    const auth = useAuthStore()

    onMounted(() => {
      if (auth.isAuthenticated) auth.refreshUser()
    })
  },
}
</script>
